(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liveon-hallmarks-marquee"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(section){
      if (section.dataset.jsDriven === '1') return;
      var viewport = section.querySelector('.lvm-marquee__viewport');
      var track    = section.querySelector('.lvm-marquee__track');
      if (!viewport || !track) return;

      var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cs = getComputedStyle(section);
      var speedStr = cs.getPropertyValue('--lvm-speed').trim();
      var speed = parseFloat(speedStr) || 40;
      var dir = section.classList.contains('lvm-marquee--dir-right') ? -1 : 1;

      section.dataset.jsDriven = '1';

      var halfWidth = 0;
      function measure(){ halfWidth = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);

      var offset = 0;
      var paused = prefersReduce;
      var dragging = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var hovering = false;
      var pauseHover = section.classList.contains('lvm-marquee--pause-hover');
      var lastTs = performance.now();

      function applyTransform(){
        if (halfWidth <= 0) return;
        offset = ((offset % halfWidth) + halfWidth) % halfWidth;
        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }

      function tick(now){
        var dt = now - lastTs;
        lastTs = now;
        if (!paused && !dragging && (!pauseHover || !hovering)) {
          var pxPerSec = halfWidth / speed;
          offset += pxPerSec * (dt / 1000) * dir;
          applyTransform();
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      if (pauseHover) {
        viewport.addEventListener('mouseenter', function(){ hovering = true; });
        viewport.addEventListener('mouseleave', function(){ hovering = false; });
      }

      function onDown(e){
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true;
        dragStartX = e.clientX;
        dragStartOffset = offset;
        viewport.classList.add('is-dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch(_){}
      }
      function onMove(e){
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        offset = dragStartOffset - dx * dir;
        applyTransform();
      }
      function onUp(e){
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(e.pointerId); } catch(_){}
      }
      viewport.addEventListener('pointerdown', onDown);
      viewport.addEventListener('pointermove', onMove);
      viewport.addEventListener('pointerup', onUp);
      viewport.addEventListener('pointercancel', onUp);
      viewport.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    function boot(){ document.querySelectorAll('.lvm-marquee').forEach(init); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target && e.target.querySelector ? e.target.querySelector('.lvm-marquee') : null;
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liveon-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var media = section.querySelector('[data-carousel]');
      if (!media) return;

      var slides = Array.prototype.slice.call(section.querySelectorAll('.lvh-hero__slide'));
      var dots   = Array.prototype.slice.call(section.querySelectorAll('[data-dot]'));
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));
      var prev   = section.querySelector('[data-prev]');
      var next   = section.querySelector('[data-next]');
      if (slides.length < 2) return;

      var idx = 0;
      var autoplay = section.dataset.autoplay === 'true';
      var loop     = section.dataset.loop === 'true';
      var interval = (parseFloat(section.dataset.interval) || 5) * 1000;
      var timer    = null;
      var paused   = false;

      function show(n) {
        if (loop) {
          idx = ((n % slides.length) + slides.length) % slides.length;
        } else {
          idx = Math.max(0, Math.min(slides.length - 1, n));
        }
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === idx);
          s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        // Keep the active thumb scrolled into view inside the strip
        var activeThumb = thumbs[idx];
        if (activeThumb && activeThumb.parentNode) {
          var strip = activeThumb.parentNode;
          var tLeft  = activeThumb.offsetLeft;
          var tRight = tLeft + activeThumb.offsetWidth;
          if (tLeft < strip.scrollLeft) {
            strip.scrollTo({ left: tLeft - 8, behavior: 'smooth' });
          } else if (tRight > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({ left: tRight - strip.clientWidth + 8, behavior: 'smooth' });
          }
        }
      }

      function start() {
        stop();
        if (!autoplay || paused) return;
        timer = setInterval(function () { show(idx + 1); }, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { show(idx + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.dotIndex, 10) || 0); start(); });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.thumbIndex, 10) || 0); start(); });
      });

      // Pause on hover / focus
      media.addEventListener('mouseenter', function () { paused = true; stop(); });
      media.addEventListener('mouseleave', function () { paused = false; start(); });
      media.addEventListener('focusin',    function () { paused = true; stop(); });
      media.addEventListener('focusout',   function () { paused = false; start(); });

      // Pause when offscreen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { start(); } else { stop(); }
          });
        }, { threshold: 0.1 });
        io.observe(media);
      }

      // Anchor link smooth scroll
      var anchor = section.querySelector('[data-anchor-scroll]');
      if (anchor) {
        anchor.addEventListener('click', function (ev) {
          var href = anchor.getAttribute('href') || '';
          if (href.charAt(0) !== '#' || href.length < 2) return;
          var tgt = document.querySelector(href);
          if (!tgt) return;
          ev.preventDefault();
          tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      start();
    }

    function boot() {
      document.querySelectorAll('.lvh-hero').forEach(init);
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);

    // Re-init on Shopify section reload (theme editor)
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) {
        var node = e.target.querySelector('.lvh-hero');
        if (node) init(node);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
